'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var sizes = exports.sizes = {
  small: '16px',
  medium: '24px',
  large: '32px',
  xlarge: '48px'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/modal-dialog/node_modules/@atlaskit/icon/es5/constants.js
// module id = 374
// module chunks = 0